import React, { useState } from 'react';
import { ThemeProvider as EmotionProvider } from 'emotion-theming';
import { ThemeContext } from './ThemeContext';
import { getTheme } from './Theme';
const ThemeProvider = ({ children }) => {
    const [colorMode, setColorMode] = useState('light');
    function toggleColorMode() {
        setColorMode(colorMode === 'light' ? 'dark' : 'light');
    }
    return (React.createElement(EmotionProvider, { theme: getTheme(colorMode) },
        React.createElement(ThemeContext.Provider, { value: {
                colorMode,
                setColorMode: toggleColorMode,
            } }, children)));
};
export default ThemeProvider;
